<template>

    <v-card class="pa-4 ma-4 " elevation="1" shaped outlined>
      <h3 class="text-right mb-6">
        فرم پرداخت الکترونیکی
      </h3>
      <v-row class="align-content-md-start">

        <v-col cols="12" md="6"  class="justify-center">
          <v-form @submit.prevent="codeRequest">
              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-autocomplete
                      v-if="$route.params.GWID"
                      dense
                      outlined
                      v-model="GW"
                      label="درگاه"
                      :items="findGWItem($route.params.GWID)"
                      item-text="Title"
                      item-value="ID"
                      no-data-text="هیچ موردی یافت نشد."
                      @change="sendGW"
                      readonly
                      id="GWID"
                  ></v-autocomplete>

                  <v-autocomplete
                      v-else
                      dense
                      outlined
                      v-model="GW"
                      label="درگاه"
                      :items="GWDDLList"
                      item-text="Title"
                      :clearable="false"
                      item-value="ID"
                      no-data-text="هیچ موردی یافت نشد."
                      @change="sendGW"
                      id="GWID"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <template v-if="$route.params.TerminalID">
                    <v-autocomplete
                        dense
                        outlined
                        v-model="TerminalID"
                        label="بابت"
                        :items="findGroupDDL($route.params.TerminalID)"
                        item-text="Name"
                        item-value="ID"
                        @change="sendInfo"
                        :readonly="$route.params.TerminalID != '-'"
                        id="TerminalID"
                    ></v-autocomplete
                    ></template>

                  <template v-else>
                    <v-autocomplete
                        dense
                        outlined
                        v-model="TerminalID"
                        label="بابت"
                        :items="groupDDLList"
                        item-text="Name"
                        :clearable="false"
                        item-value="ID"
                        no-data-text="هیچ موردی یافت نشد."
                        @change="sendInfo"
                        id="TerminalID"
                    ></v-autocomplete>
                  </template>
                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      v-if="$route.params.Amount"
                      :rules="[rules.required, rules.matchAmount]"
                      :type="show1 ? 'text' : 'Amount'"
                      dense
                      outlined
                      :value="fillAmount($route.params.Amount)"
                      label="مبلغ (به ریال)"
                      :readonly="$route.params.Amount != '-'"
                      id="Amount"
                  >
                  </v-text-field>

                  <v-text-field
                      v-if="!$route.params.Amount"
                      :rules="[rules.required, rules.matchAmount]"
                      :type="show1 ? 'text' : 'Amount'"
                      dense
                      outlined
                      v-model="formatted_amount"
                      label="مبلغ (به ریال)"
                      :readonly="!userGroupLoad.Allow_Change_Amount"
                      id="Amount"
                  >
                  </v-text-field>

                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      dense
                      outlined
                      v-model="memo"
                      :value="$route.params.memo"
                      :class="{ invisible: !userGroupLoad.Memo_Enable }"
                      :label="userGroupLoad.Memo_Title"
                      :readonly="$route.params.Memo"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      :rules="[rules.required, rules.matchNC]"
                      :type="show2 ? 'text' : 'NC'"
                      dense
                      outlined
                      v-model="NC"
                      label="کدملی"
                      :class="{ invisible: !userGroupLoad.NC_Enable }"
                      :readonly="$route.params.NC && $route.params.NC!=='-'"
                      id="NC"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      :rules="[rules.required, rules.matchName]"
                      :type="show3 ? 'text' : 'Name'"
                      dense
                      outlined
                      v-model="name"
                      label="نام"
                      :class="{ invisible: !userGroupLoad.Name_Enable }"
                      :readonly="$route.params.Name && $route.params.Name!=='-'"
                      id="Name"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      :rules="[rules.required, rules.matchFamily]"
                      :type="show4 ? 'text' : 'Family'"
                      dense
                      outlined
                      v-model="family"
                      label="نام خانوادگی"
                      :class="{ invisible: !userGroupLoad.Family_Enable }"
                      :readonly="$route.params.Family && $route.params.Family!=='-'"
                      id="Family"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="justify-center">
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      :rules="[rules.required, rules.matchMobile]"
                      :type="show6 ? 'text' : 'Mobile'"
                      dense
                      outlined
                      v-model="mobile"
                      label="موبایل"
                      :class="{ invisible: !userGroupLoad.Mobile_Enable }"
                      :readonly="$route.params.Mobile && $route.params.Mobile!=='-'"
                      id="Mobile"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="justify-center" >
                <v-col cols="10" class="mx-6">
                  <v-text-field
                      :rules="[rules.required, rules.matchEmail]"
                      :type="show7 ? 'text' : 'Email'"
                      dense
                      outlined
                      v-model="email"
                      label="ایمیل"
                      :class="{ invisible: !userGroupLoad.EMail_Enable }"
                      :readonly="$route.params.Email && $route.params.Email!=='-'"
                      id="Email"
                  ></v-text-field>
                </v-col>
              </v-row>
            <v-row class="justify-center">
              <v-col cols="10" class="mx-6">
                <template>
                  <v-text-field
                      :rules="[rules.required, rules.matchTel]"
                      :type="show5 ? 'text' : 'Tel'"
                      dense
                      outlined
                      v-model="telephone"
                      label="تلفن(با پیش شماره)"
                      :class="{ invisible: !userGroupLoad.Tel_Enable }"
                      :readonly="$route.params.Tel && $route.params.Tel!=='-'"
                      id="Tel"
                  ></v-text-field>
                </template>
              </v-col>
            </v-row>
              <v-row class="justify-center">
                <v-col  cols="12" sm="6">
<!--                  <v-btn :disabled="!FormValid" color="success" class="ma-4" small @click="approve">-->
<!--                    ثبت درخواست-->
<!--                  </v-btn>-->
                  <v-btn
                      depressed
                      :loading="loadReportIsLoading==='User_Payment_Insert'"
                      :disabled="!FormValid"
                      color="success"
                      @click="approve"
                      rounded
                      large
                      width="100%"
                  >
                   ثبت درخواست
                  </v-btn>
                  <!--<v-btn
                    color="success"
                    class="ma-4"
                    small
                    :disabled="flag"
                    to="/submit"
                  >
                    مشاهده فاکتور
                  </v-btn>-->
                </v-col>
              </v-row>
          </v-form>
        </v-col>

        <v-col cols="12" md="6">

          <v-card class="mx-4 " elevation="1" shaped outlined>
            <v-row class="justify-center " order="2">
              <v-col cols="12" sm="12"  md="12" class="mr-xs-6">
                <v-row class="justify-center my-2">

                  <img alt="" class="logo_image " src="../assets/images/header_logo.png">
                  <div v-html="institute_info.enamad"></div>

                  <!--                <v-col cols="12" xs="4" sm="4"  >-->
                  <!--                  <v-img width="80%" height="80%" src="../assets/images/BPM.gif"></v-img>-->
                  <!--                </v-col>-->

<!--                  <v-col cols="12" xs="4" sm="6"  v-html=" institute_info.enamad">-->
<!--                            </v-col>-->

                </v-row>

              </v-col>

            </v-row>
            <v-row class="mx-4 mb-4 SecurityTips">
              <v-col cols="12">
                <h3 class="mb-4">
                  <v-icon color="yellow" small> mdi-star</v-icon>
                  نکات امنیتی پرداخت الکترونیکی
                  {{  }}
                </h3>
                <p>
                  {{ institute_info.Title }} و بانك هيچگاه و به هيچ طريقي (تلفني، پيامكي
                  و .ايميل) درخواست اطلاعات كارت بانكي و رمز عبور آن را نخواهند
                  داشت
                </p>
                <p>
                  از رمزهای ساده استفاده نكنید و از انتخاب شماره شناسنامه، کد ملی و تاریخ
                  تولد خود و یا خانواده ، پلاك خانه و شماره تلفن خودداری نمایید.
                </p>
                <p>
                  رمز خود را جایی یادداشت نكنید و در صورت یادداشت نمودن آن را در
                  جیب یا كیف پول به همراه كارت قرار ندهید.
                </p>
                <p>رمزهای عبور خود را به صورت دوره ای تغییر دهید.</p>
                <p>رمز خود را در اختیار سایر افراد قرار ندهید.</p>
                <p>
                  اطلاعات حساس از جمله رمز خود را از طریق تلفن برای دیگران بازگو
                  نكنید.
                </p>
                <p>
                  در صورت فاش شدن رمز خود، در كوتاهترین زمان ممكن آن را عوض
                  نمایید.
                </p>
                <p>
                  كارت و رمز خود را به هیچ وجه در اختیار دیگران قرار ندهید .
                  بعضاً افراد سود جو به بهانه كمك كردن و راهنمایی ضمن اخذ كارت و
                  رمز شما پس از انجام عملیات كارت شما را با كارت دیگری (سرقتی ،
                  مفقودی ، باطله و...) معاوضه نموده و حساب شما را مورد سوء
                  استفاده قرار می دهند.
                </p>
                <p>
                  در صورت انجام انتقال وجه و عملیات اینترنتی برروی حساب خود در
                  مرورگرهای اینترنت گزینه ی به خاطرسپردن رمز را انتخاب نكنید.
                  این گزینه با نام كلی Remember Password شناخته می شود، از این
                  قابلیت استفاده نكنید.
                </p>
                <p>
                  برای ارسال اطلاعات حساس خود از پست الكترونیكی استفاده ننمایید.
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!--      loading overlay-->
      <v-overlay :value="loadReportIsLoading==='User_GW_DDL' || loadReportIsLoading==='User_Group_DDL' || loadReportIsLoading==='User_Group_Load' ">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-overlay>
      <!--      loading overlay-->
    </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Form",
  data: () => ({
    formatted_amount:"",
    FormValid:true,
    input_amount:"",
    GW: "",
    TerminalID: "",
    amount: "",
    NC: "",
    name: "",
    family: "",
    telephone: "",
    mobile: "",
    email: "",
    memo: "" ,
    show1: false,
    show2: false,
    show3: false,
    show4: false,
    show5: false,
    show6: false,
    show7: false,
    rules: {
      // required: (value) => !!value || "این فیلد اجباری است.",
      // matchAmount: (value) => value.replaceAll(",","") > 5000 || "مبلغ باید بیشتر از 5000 باشد.",
      // matchNC: (value) =>
      //   value.length === 10 || "کدملی کمتر از 10 عدد قابل قبول نیست.",
      // matchName: (value) =>
      //   value.length > 2 || "نام باید حداقل شامل سه حرف باشد.",
      // matchFamily: (value) =>
      //   value.length > 1 || "نام خانوادگی باید حداقل شامل دو حرف باشد.",
      // matchTel: (value) => value.length === 11 || "تلفن معتبر نیست",
      // matchMobile: (value) =>
      //     (/^09[0-9]{9}$/.test(value) || /^۰۹[۰-۹]{9}$/.test(value) )|| "تلفن همراه معتبر نیست.",
      // matchEmail: (value) =>
      //   /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value) || "ایمیل معتبر نیست",
    }
  }),
  watch:{
    formatted_amount:function (new_value){
      if(new_value==null || new_value.replace(/\D/g,'') === "" ){
        this.userGroupLoad.Default_Amount="";
        return "";

      }

      this.formatted_amount=parseInt(new_value.replace(/\D/g,''),10).toLocaleString();
      this.userGroupLoad.Default_Amount=new_value.replaceAll(",","");
    },
    userGroupLoad:function (new_value){
      this.formatted_amount=new_value.Default_Amount+"";
    },

  },
  computed:{
    ...mapState({
    GWDDLList: (state) => state.userGWDDL,
    groupDDLList: (state) => state.userGroupDDL,
    userGroupLoad: (state) => state.userGroupLoad,
    flag: (state) => state.flag,
    loadReportIsLoading: (state) => state.loadReportIsLoading, //TODO::Look ME!!!
    institute_info: (state)=> state.institute_info,
    getFocus: (state)=> state.focus !=''? state.focus: ''
    })},

  created: function () {
    //  window.console.log(this.$route.params , 'asdasdasdasd');
    this.FormValid = true;
    if (this.$route.params.GWID){
      this.GW = parseInt(this.$route.params.GWID);
        window.console.log(this.GW , 'this.GW')
      this.sendGW();//onchange GWID
    }
    if (this.$route.params.TerminalID){
        this.TerminalID= parseInt(this.$route.params.TerminalID);
        this.sendInfo();//onchange TerminalID
    }
    if(this.$route.params.Amount){
      // if(this.$route.params.Amount == '-'){
      //   this.Amount = '';
      // }
        this.Amount=this.$route.params.Amount;
    }
    if (this.$route.params.memo){
      if(this.$route.params.memo == '-'){
      this.memo = ''  
      }
      else{
        this.memo = this.$route.params.memo;
      }
    }
    if(this.$route.params.NC){
      if(this.$route.params.NC == '-'){
        this.NC = ''
      }
      else{
        this.NC=this.$route.params.NC;
      }
    }
    if(this.$route.params.Name){
      if(this.$route.params.Name == '-'){
        this.name = ''
      }
      else{
        this.name=this.$route.params.Name;
      }
    }
    if(this.$route.params.Family){
      if(this.$route.params.Family == '-'){
        this.family = ''  
      }
      else{
        this.family=this.$route.params.Family;
      }
    }
    if(this.$route.params.Tel){
      if(this.$route.params.Tel == '-'){
      this.telephone = ''  
      }
      else{
        this.telephone=this.$route.params.Tel;
      }
    }
    if(this.$route.params.Mobile){
      if(this.$route.params.Mobile == '-'){
      this.mobile = ''  
      }
      else{
        this.mobile=this.$route.params.Mobile;
      }
    }
    if(this.$route.params.Email){
      if(this.$route.params.Email == '-'){
      this.email = ''  
      }
      else{
        this.email=this.$route.params.Email;
      }
    }
    this.flag = true;
    this.$store.commit("changeFlag", { flag: true });
    this.setDefaults();
    this.$store.commit("pushQueue", {
      functionName: "User_GW_DDL",
      data: {},
    });

    window.console.log("****** In Form Component *********");
    /*if(this.$store.params.GWID)
               window.console.log(parseInt(this.$route.params.GWID));
              if(this.$store.params.TerminalID)
               window.console.log(parseInt(this.$route.params.TerminalID));
             if(this.$store.params.Amount)
               window.console.log(parseInt(this.$route.params.Amount));  */
    //window.console.log(this.$store.params.TerminalID)
    //window.console.log(this.$store.params.Amount)
    //this.fillAmount(this.$route.params.Amount);
  },
  methods: {
    // change_to_number_format(){
    //   // let number_formated_price = parseInt(vm.userGroupLoad.Default_Amount.replace(/\D/g,''),10);
    //   this.userGroupLoad.Default_Amount=this.userGroupLoad.Default_Amount.toLocaleString();
    // },
    setDefaults() {
      // liste babatha khali shavad(Mohandes Shakiba)
      this.$store.commit("updateGroupDDLList", []);
      this.userGroupLoad.Default_Amount = 0;
      this.userGroupLoad.EMail_Enable = false;
      this.userGroupLoad.Family_Enable = false;
      this.userGroupLoad.Memo_Enable = false;
      this.userGroupLoad.Memo_Title = "";
      this.userGroupLoad.Mobile_Enable = false;
      this.userGroupLoad.NC_Enable = false;
      this.userGroupLoad.Name_Enable = false;
      this.userGroupLoad.Tel_Enable = false;
    },

    sendGW() {
      this.setDefaults();
      this.TerminalID="";
      this.groupDDLList=[];
      this.formatted_amount ="";
      this.NC = "";
      this.name = "";
      this.family = "";
      this.telephone = "";
      this.email = "";
      this.mobile = "";
      if (this.GW ===null) {
        this.TerminalID="";
        this.groupDDLList=[];
        return;
      }

      this.$store.commit("pushQueue", {
        functionName: "User_Group_DDL",
        data: {
          GWID: this.GW,
        }
      });
    },
    sendInfo() {
      window.console.log("on change is fired! :D");
      this.$store.commit("pushQueue", {
        functionName: "User_Group_Load",
        data: {
          GWID: this.GW,
          TerminalID: this.TerminalID,
        }
      });
      window.console.log("***** In sendInfo function*******");
      window.console.log(this.userGroupLoad);
    },

    approve() {
      this.$store.commit("pushQueue", {
        functionName: "User_Payment_Insert",
        data: {
          GWID: this.GW,
          TerminalID: this.TerminalID,
          Amount: this.userGroupLoad.Default_Amount,
          NC: this.NC,
          Name: this.name,
          Family: this.family,
          Tel: this.telephone,
          Mobile: this.mobile,
          EMail: this.email,
          Memo: this.memo
        }
      });
        setTimeout(() => {
          if(this.getFocus != ""){
            document.querySelector(`#${this.getFocus}`).focus();
          }
        }, 1000);
      
    },
    format(text) {
      return Number(text).toLocaleString();
    },
    findGWItem(ID) {
      return this.GWDDLList.filter((item) => item.ID == ID);
    },
    findGroupDDL(ID) {
      return this.groupDDLList.filter((item) => item.ID == ID);
    },
    fillAmount(amount) {
      if(amount == '-'){
        this.Amount = ''
        return;
      }
      if (this.userGroupLoad.Allow_Change_Amount) {
        this.userGroupLoad.Default_Amount = amount;
      }
      return parseInt(amount.replace(/\D/g,''),10).toLocaleString();

    }
  }
};


</script>


<style scoped>
body {
  height: 100%;
}

p {
  text-align: right;
  line-height: initial;
}

.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin: -12px;
  font-size: x-small;
}

.invisible {
  display: none;
}
.SecurityTips{
  font-size: small;
}
.logo_image{
  margin-top: 20px;
  width: 15%;
  height: 15%;
}

</style>
